export const calculateDuration = (startTime: Date, endTime: Date): string => {
  const updatedStartTime = new Date(startTime);
  const updatedEndTime = new Date(endTime);

  if (isNaN(updatedStartTime.getTime()) || isNaN(updatedEndTime.getTime())) return "00:00";

  const diffInMilliseconds = updatedEndTime.getTime() - updatedStartTime.getTime();
  if (diffInMilliseconds <= 0) return "00:00";

  const hours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
  const minutes = Math.floor((diffInMilliseconds / (1000 * 60)) % 60);

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};
